class AssetsServ {
    constructor(shopTypesServ) {
        this.shopTypesServ = shopTypesServ;
    }

    getAssetByTypeAndDevicePixelRatio(type, devicePixelRatio) {
        switch (type) {
            // Clusterer
            case 'clusterer':
                return 'assets/map/marker-clusterer/cluster-or.svg';
            // User location marker
            case 'user-location':
                return 'assets/map/markers/user-location.png';
            // Shop marker
            case this.shopTypesServ.getTypeShop():
                return 'assets/map/markers/poi-or.svg';
            // Store marker
            case this.shopTypesServ.getTypeStore():
                return 'assets/map/markers/poi-yl.svg';
            // Smart Store marker
            case this.shopTypesServ.getTypeSmartStore():
                return 'assets/map/markers/poi-bl.svg';
            // Strategic marker
            case this.shopTypesServ.getTypeStrategic():
                return 'assets/map/markers/poi-gr.svg';
            // Dealer marker
            case this.shopTypesServ.getTypeDealer():
                return 'assets/map/markers/poi-gr.svg';
            // Orange Money Merchant marker
            case this.shopTypesServ.getTypeOmMerchant():
                return 'assets/map/markers/poi-pr.svg';
            case this.shopTypesServ.getTypeTkr():
                return 'assets/map/markers/poi-pr.svg';
            // Fashion
            case this.shopTypesServ.getSubTypeFashion():
                return this._getFashionIconByDevicePixelRatio(devicePixelRatio);
            // Supermarket
            case this.shopTypesServ.getSubTypeSupermarket():
                return this._getSupermarketIconByDevicePixelRatio(devicePixelRatio);
            // Restaurant
            case this.shopTypesServ.getSubTypeRestaurants():
                return this._getRestaurantsIconByDevicePixelRatio(devicePixelRatio);
            // Free time
            case this.shopTypesServ.getSubTypeFreeTime():
                return this._getFreeTimeIconByDevicePixelRatio(devicePixelRatio);
            // Health
            case this.shopTypesServ.getSubTypeHealth():
                return this._getHealthIconByDevicePixelRatio(devicePixelRatio);
            // Services
            case this.shopTypesServ.getSubTypeServices():
                return this._getServicesIconByDevicePixelRatio(devicePixelRatio);
            // Electronics
            case this.shopTypesServ.getSubTypeElectronics():
                return this._getElectronicsIconByDevicePixelRatio(devicePixelRatio);
            // Market
            case this.shopTypesServ.getSubTypeMarket():
                return this._getMarketIconByDevicePixelRatio(devicePixelRatio);
            default:
                return '';
        }
    }

    _getFashionIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinFashion@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinFashion@2x.png';
            default:
                return 'assets/map/markers/locationPinFashion.png';
        }
    }

    _getSupermarketIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinMarket@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinMarket@2x.png';
            default:
                return 'assets/map/markers/locationPinMarket.png';
        }
    }

    _getRestaurantsIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinRestaurant@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinRestaurant@2x.png';
            default:
                return 'assets/map/markers/locationPinRestaurant.png';
        }
    }

    _getFreeTimeIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinFreetime@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinFreetime@2x.png';
            default:
                return 'assets/map/markers/locationPinFreetime.png';
        }
    }

    _getHealthIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinHealth@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinHealth@2x.png';
            default:
                return 'assets/map/markers/locationPinHealth.png';
        }
    }

    _getServicesIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinServices@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinServices@2x.png';
            default:
                return 'assets/map/markers/locationPinServices.png';
        }
    }

    _getElectronicsIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinElectronics@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinElectronics@2x.png';
            default:
                return 'assets/map/markers/locationPinElectronics.png';
        }
    }

    _getMarketIconByDevicePixelRatio(devicePixelRatio) {
        switch (devicePixelRatio) {
            case '3x':
                return 'assets/map/markers/locationPinGeneral@3x.png';
            case '2x':
                return 'assets/map/markers/locationPinGeneral@2x.png';
            default:
                return 'assets/map/markers/locationPinGeneral.png';
        }
    }
}

AssetsServ.$inject = ['shopTypesServ'];

export default AssetsServ;
